<template>
  <div class="container">
    <div class="container_flex">
      <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
      <div class="container-content">
        <div class="content-title">医生列表</div>
        <div class="query">
          <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
        </div>
        <div class="table">
          <MyTable :table-options="tableOptions" border max-height="65vh">
              <template #dictDataId="{ row }">
                {{ getFind(row.dictDataId) }}
            </template>
            <template #sex="{ row }">
              {{ ['男','女'][row.sex-1] }}
            </template>
                <template #remarks="{ row }">
                    <el-tooltip
                      popper-style="width:200px"
                      effect="dark"
                      :content="row.remarks"
                      placement="top-start"
                    >
                      <el-text truncated style="color: #6fcaf7">{{row.remarks}}</el-text>
                    </el-tooltip>
            </template>
            <template #handler="{ row }">
              <!-- <el-button
                style="color: #6fcaf7"
                icon="View"
                link
                @click="click_view(row)"
                >查看</el-button
              > -->
              <el-button
                style="color: #6fcaf7"
                icon="Edit"
                link
                @click="click_edit(row)"
                >编辑</el-button
              >
              <ConfirmButton
                style="color: #6fcaf7"
                icon="Delete"
                link
                @confirm="click_delete(row)"
                >删除</ConfirmButton
              >
            </template>
          </MyTable>
          <MyPagination :params="paginationParams" :total="total" @get-list="getList" ref="paginationRef" />
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <Dialog
      width="50%"
      v-model="dialogVisible"
      title="新增"
      top="5vh"
    >
      <MyForm
        class="add-user-form"
        :formOptions="addUserForm"
        :inline="true"
        ref="myFormRef"
        label-width="auto"
      >
        <template #isRecommend="{ formData }">
           <el-switch v-model="formData.isRecommend" />
        </template>
        <template #doctorAvatar="{ formData }">
          <ImgUpload class="row-span2" v-model="formData.profilePhoto" />
        </template>
      </MyForm>
      <div class="submit-buttons">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="click_addUser_confirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import { computed, nextTick, reactive, ref } from "vue";
import MyPagination from "@/components/Global/MyPagination.vue"
import OrganizationTree from "@/components/Common/OrganizationTree.vue";;
import { ElMessage } from "element-plus";
import Dialog from "@/components/Common/Dialog.vue";
import authApi from "@/api/auth";
import ImgUpload from "@/components/Common/ImgUpload.vue";;
import dictionary from "@/api/dict.js";
import roleApi from "@/api/role";
// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "关键字：",
      prop: "Name",
      attrs:{
        placeholder: "请输入关键词"
      }
    },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
        },
        events: {
          click(formData) {
            paginationParams.Name = formData.Name;
          },
        },
      },
      {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "RefreshLeft",
        },
        events: {
          click(formData) {
            paginationParams.Name = "";
          },
        },
      },
      {
        type: "Button",
        value: "添加",
        attrs: {
          icon: "Plus",
        },
        events: {
          click(formData) {
            Flag.value = 0;
            dialogVisible.value = true;
          },
        },
      },
    ]
  ],
});

const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 70 },
    { label: "登录名", prop: "loginUser" },
    { label: "姓名", prop: "userName" },
    { label: "手机号码", prop: "phone" },
    { label: "类别", type: "slot", slot_name: "dictDataId" },
    { label: "性别", type: "slot", slot_name: "sex" },
    { label: "头衔", prop: "title" },
    { label: "擅长领域", prop: "adept" },
    { label: "个人简介", type: "slot",slot_name: "remarks", },
    { type: "slot", slot_name: "handler", label: "操作", width: 200 },
  ],
  tableData: [],
});
const getFind=(id)=>{
      const target =CategoryList.value.find(item => item.id === id)
      return target.name
}
// 分页
const paginationParams = reactive({
  Name: "",
  Type: 2,
  OrganizationId:"",
})
const nodeClick = (data) => {
  paginationParams.OrganizationId = data.id;
  // getList();
};
const paginationRef = ref(null);
const total = ref(0);
const getList = (params = paginationRef.value.getList_params) => {
  if(paginationParams.OrganizationId==""){
      return
  }
  authApi.getUserList(params).then((res) => {
    console.log(res,"+++++")
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items
  })
}

//字典类别
const CategoryList = ref([]);
const getListCategoryData = () => {
  dictionary.getList({
    OrganizationId:"3a1dcd29-4d09-736f-1174-7ae7b6d32b3f",
    Code: "doctortype",
  }).then((res) => {
    console.log(res,"类别")
    CategoryList.value = res.data.items.map(item=>{
      return {
        label: item.name,
        value: item.id,
        ...item
      }
    });
  })
}
getListCategoryData();

const dialogVisible = ref(false);
const itemList = computed(() => {
  const base = [
    {
      type: "Input",
      label: "登录名：",
      prop: "loginUser",
      attrs:{
        placeholder: "请输入登录名"
      }
    },
    {
      type: "Input",
      label: "密码：",
      prop: "password",
      attrs:{
        placeholder: "请输入密码"
      }
    },
    {
      type: "Input",
      label: "姓名：",
      prop: "userName",
      attrs:{
        placeholder: "请输入姓名"
      }
    },
    {
      type: "Input",
      label: "手机号码：",
      prop: "phone",
      attrs:{
        placeholder: "请输入手机号"
      }
    },
    {
      type: "Select",
      label: "咨询师类别：",
      prop: "dictDataId",
      options: CategoryList,
      attrs:{
        placeholder: "请选择"
      }
    },
    {
      type: "Input",
      label: "头衔：",
      prop: "title",
      attrs:{
        placeholder: "请输入头衔"
      }
    },
    {
      type: "Input",
      label: "擅长领域：",
      prop: "adept",
      attrs:{
        placeholder: "输入内容以','分割"
      }
    },
    {
      type: "Radio",
      label: "性别：",
      prop: "sex",
      defaultValue: 1,
      options: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
      ],
    },
    {
      type: "Input",
      label: "个人简介：",
      prop: "remarks",
      attrs:{
        type: "textarea",
        // class:["row-span2"]
      }
    },
    {
      type: "Slot",
      label: "医生头像：",
      prop: "profilePhoto",
      slot_name: "doctorAvatar",
      // attrs:{
      //   class:["row-span2"]
      // }
    },
    {
      type: "Slot",
      label: "是否推荐：",
      prop: "isRecommend",
      slot_name: "isRecommend",
    },
  ];
  if (Flag.value === 0) {
    base.splice(1, 1, {
      type: "Input",
      label: "密码",
      prop: "password",
    });
  } else {
    base.splice(1, 1, {
      type: "Input",
      label: "密码",
      prop: "_password",
      defaultValue: "**********",
      attrs: {
        readonly: true,
      },
    });
  }
  return base;
});
const Flag = ref(0);
const readonly = computed(() => Flag.value === 2); //只读
const addUserForm = reactive({
  itemList: itemList,
  rules: {
    userName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
    loginUser: [{ required: true, message: "账号不能为空", trigger: "blur" }],
    password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
    phone: [
      { required: true, message: "手机号不能为空", trigger: "blur" },
      { pattern: /^1\d{10}$/, message: "手机号格式不正确", trigger: "blur" },
    ],
    dictDataId: [{ required: true, message: "类别不能为空", trigger: "blur" }],
  },
  commonAttrs: {
    readonly,
  },
});


// 添加用户确认
const myFormRef = ref(null);
const click_addUser_confirm = () => {
  if (Flag.value === 2) return (dialogVisible.value = false); //查看
  const { formRef, formData } = myFormRef.value;
  console.log(" formData:", formData)
  formRef.validate(async(valid) => {
    if (valid) {
      formData.type = 2;
      formData.OrganizationId = paginationParams.OrganizationId;
      console.log(formData.id)
      let res = formData.id ? await authApi.editUser(formData):await authApi.addUser(formData);
      if(!formData.id){
           await roleApi.bindUser({
            userId: res.data.id,
            roleId: "3a197e92-072a-af3e-dc5a-9a850768e805",
          });
      }
      ElMessage.success("操作成功");
      dialogVisible.value = false;
      getList();
    }
  })
};


const click_view = async(row) => {
  Flag.value = 2;
  dialogVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
}

const click_edit = async(row) => {
  Flag.value = 1;
  dialogVisible.value = true;
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
}
const click_delete = (row) => {
  authApi.deleteUser(row.id).then((res) => {
    ElMessage.success("删除成功");
    getList();
  })
}
</script>

<style lang="scss" scoped>
.container_flex{
    display: flex;
    .container-content{
      flex:1;
      margin-left: 20px;
    }
}
.box-item{
  width: 200px !important;
}
.add-user-form {
  padding: 0 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  :deep(){
    .el-input,.el-select {
      width: 100%;
      height: 40px;
    }
    .el-select__wrapper{
      width: 100%;
      height: 100%;
    }
    .el-form-item:has(.row-span2){
      grid-row-start: span 2;
      .el-textarea,.el-textarea__inner{
        height: 100%;
      }
    }
    .el-form-item:has(.column-span2){
      grid-column-start: span 2;
    }
  }
}
</style>
